import { useMemo } from 'react';

import { getServerErrorText } from 'shared/lib';
import { ErrorMessage, EmptyData } from 'shared/ui';

import { useGetDiscountsQuery } from 'entities/discount';

import { DiscountsTableInstance } from './table';

export function ConnectedDiscountsTable() {
  const { data, isFetching, error } = useGetDiscountsQuery();

  const tableData = useMemo(() => {
    if (!data) {
      return [];
    }

    return data.discounts;
  }, [data]);

  if (data && data.statusCode !== 0) {
    return <ErrorMessage text={data.statusDescription} />;
  }

  if (error) {
    return <ErrorMessage text={getServerErrorText(error)} />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  return (
    <DiscountsTableInstance
      tableData={tableData}
      loading={isFetching}
      rowsCount={data?.discounts.length}
    />
  );
}
